export const dependentsFormFields = ['first_name',
    'middle_name',
    'last_name',
    'name_suffix',
    'ssn',
    'sin',
    'gender',
    'birthdate',
    'relationship_code',
    'address_1',
    'address_2',
    'city',
    'lives_at_home',
    'state',
    'zip_code',
    'country',
    'verified',
    'verification_expires_on',
    'qmcso',
    'medicare_reason',
    'medicare_plan',
    'medicare_termination_date',
    'medicare_effective_date',
    'medicare_termination_date',
    'is_smoker',
    'enroll_in_medicare',
    'udef_1',
    'udef_2',
    'udef_3',
    'udef_4',
    'udef_5',
    'udef_6',
    'udef_7',
    'udef_8',
    'udef_9',
    'udef_10'];